import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  SendDocumentsClientRequest,
  SendDocumentsClientResponse,
} from '../../../@types/SendDocumentsByEmail'
import { api } from '../../../Services/API'
import { useReportStore } from '../../../Stores/reportStore'
import { useSendDocumentsByEmailStore } from '../../../Stores/useSendDocumentsByEmailStore'
import { useWarningStore } from '../../../Stores/warningStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { WARNING_BAR } from '../../../constants/warningBar'
import { t } from '../../../i18n'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: SendDocumentsClientRequest) => {
  const response = await api.post<SendDocumentsClientResponse>(
    API_ROUTES.sendDocumentsByEmail,
    payload,
  )

  return response.data
}

export const useSendDocumentsByEmail = () => {
  const { handleErrorRequest } = useErrorRequest()
  const { setSendDocumentsByEmail } = useSendDocumentsByEmailStore()
  const { setWarningOptions } = useWarningStore()
  const { setSentEmail } = useReportStore()

  return useMutation({
    mutationFn: (payload: SendDocumentsClientRequest) => request(payload!),
    onSuccess(data) {
      setSendDocumentsByEmail(data)

      setSentEmail(true)
      setWarningOptions({
        type: WARNING_BAR.type.success,
        labelTypes: [t('general.success.emailSent')],
        mode: WARNING_BAR.mode.show,
      })
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({
        message: t('pages.step2.report.errors.emailNotSent'),
        error,
      })
    },
  })
}
